import { Box, Button } from '@material-ui/core'
import React from 'react'
import { connect } from 'react-redux'
import { isPristine, isValid, submit } from 'redux-form'

import ButtonSubmit from '../../common/ButtonSubmit'

const EditProfileButtons = ({
  changePersonalInfoEditingMode,
  dispatch,
  formName,
  isEditing,
  pristine,
  submitting,
  valid,
}) =>
  isEditing ? (
    <Box display="flex" flexDirection="row" justifyContent="space-between">
      <Button onClick={() => changePersonalInfoEditingMode(false)} size="small">
        Cancel
      </Button>
      <ButtonSubmit
        color="primary"
        disabled={!valid || pristine}
        onClick={() => dispatch(submit(formName))}
        size="small"
        submitting={submitting}
      >
        Save Changes
      </ButtonSubmit>
    </Box>
  ) : (
    <Button color="primary" onClick={() => changePersonalInfoEditingMode(true)} size="small">
      Edit Profile
    </Button>
  )
const mapStateToProps = (state, ownProps) => ({
  pristine: isPristine(ownProps.formName)(state),
  valid: isValid(ownProps.formName)(state),
})

export default connect(mapStateToProps)(EditProfileButtons)
